/**
 * Prime Review (mxpr) アプリが生成する DOM への共通カスタマイズ。
 *
 * テーマからアプリのソースを編集できないため、描画後の DOM を JS で補正する。
 *   1. 投稿フォームの注意書き `.mxpr-form-notice` を二次利用同意文言で上書き
 *   2. レビュー要約のキャンペーン文言を、擬似要素ではなく実要素
 *      `.mxpr-summary__header-tips` として `.mxpr-summary__info` 直前に挿入
 *      （既存の擬似要素はスニペット同梱の CSS で無効化）
 *
 * 文言はスクリプトタグの data-* 属性から受け取る（Liquid `| t` 由来）。
 * 対象要素が無ければ何もしない。アプリの遅延描画・再描画に備え、
 * 単一の MutationObserver で短時間だけ後追い適用する。
 */
(function () {
  'use strict';

  const script =
    document.currentScript || document.querySelector('script[data-prime-review]');
  if (!script) {
    return;
  }

  const consentText = script.getAttribute('data-consent');
  // 各文言は data-<name> 属性で渡され、クラス名は mxpr-summary__header-tips__<name>
  const summaryTipNames = ['campaign', 'photo'];

  // (1) 投稿フォームの注意書きを同意文言で上書き
  // textContent 一致ガードにより、自前の更新では監視ループにならない
  function applyConsentNotice() {
    if (!consentText) {
      return;
    }
    document.querySelectorAll('.mxpr-form-notice').forEach(function (notice) {
      if (notice.textContent !== consentText) {
        notice.textContent = consentText;
      }
    });
  }

  // (2) レビュー要約のキャンペーン文言を実要素として挿入
  function buildSummaryTips() {
    document.querySelectorAll('.mxpr-summary__info').forEach(function (info) {
      const prev = info.previousElementSibling;
      if (prev && prev.classList.contains('mxpr-summary__header-tips')) {
        return;
      }

      const container = document.createElement('div');
      container.className = 'mxpr-summary__header-tips';

      summaryTipNames.forEach(function (name) {
        const text = script.getAttribute('data-' + name);
        if (!text) {
          return;
        }
        const line = document.createElement('p');
        line.className = 'mxpr-summary__header-tips__' + name;
        line.textContent = text;
        container.appendChild(line);
      });

      info.insertAdjacentElement('beforebegin', container);
    });
  }

  function apply() {
    applyConsentNotice();
    buildSummaryTips();
  }

  function init() {
    apply();

    // アプリの遅延描画・再描画に備え、短時間だけ監視して再適用する
    const observer = new MutationObserver(apply);
    observer.observe(document.body, { childList: true, subtree: true });

    // 安全装置: 一定時間で監視を打ち切る
    setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
